import { OrganisationOverview } from './../../dataSource/organisationDataSource';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { DialogAddProductToNodeComponent } from 'src/app/components/composer/dialog-add-product-to-node/dialog-add-product-to-node.component';
import { DialogToolchainInstanceUploadDataComponent } from 'src/app/components/composer/dialog-toolchain-instance-upload-data/dialog-toolchain-instance-upload-data.component';
import { DialogEditMetaDataComponent } from 'src/app/components/composer/model-editor/dialog-edit-meta-data/dialog-edit-meta-data.component';
import { DialogAttributeCreate } from 'src/app/components/dialog-windows/dialog-attribute-create';
import { DialogCertReqChangeStatusComponent } from 'src/app/components/dialog-windows/dialog-certReq-change-status.component';
import { DialogCommonFeatureProductCreationComponent } from 'src/app/components/dialog-windows/dialog-common-feature-product-creation/dialog-common-feature-product-creation.component';
import { DialogConfirmComponent } from 'src/app/components/dialog-windows/dialog-confirm.component';
import { DialogDelegateCertificationComponent } from 'src/app/components/dialog-windows/dialog-delegate-certification.component';
import { DialogDeleteUserManageOrganisationsComponent } from 'src/app/components/dialog-windows/dialog-delete-user-manage-organisations/dialog-delete-user-manage-organisations.component';
import { DialogFileManagerComponent } from 'src/app/components/dialog-windows/dialog-filemanager.component';
import { DialogOverviewExampleDialogComponent } from 'src/app/components/dialog-windows/dialog-overview-example-dialog.component';
import { DialogRemoveMemberConfirmComponent } from 'src/app/components/dialog-windows/dialog-remove-member-confirm/dialog-remove-member-confirm.component';
import { DialogRequestComponent } from 'src/app/components/dialog-windows/dialog-request/dialog-request.component';
import { RequestType } from 'src/app/model/enums/request-type';
import { DialogCertRequestComponent } from 'src/app/components/dialog-windows/dialog-request/dialog-certRequest.component';
import { DialogText } from 'src/app/components/dialog-windows/dialog-text';
import { DialogAgb } from 'src/app/components/dialog-windows/dialog-agb-text/dialog-agb';
import { PackageModel } from 'src/app/model/stripe-models/product/package-model';
import { DialogPrivacy } from 'src/app/components/dialog-windows/dialog-privacy-text/dialog-privacy';
import { DialogTarifeComponent } from 'src/app/components/dialog-windows/dialog-tarife/dialog-tarife.component';
import { DialogReportReviewComponent } from 'src/app/components/dialog-windows/report-review/report-review.component';
import { DialogRevokeCertificationComponent, RevokeCertificationDialogData } from 'src/app/components/dialog-windows/dialog-revoke-certification/dialog-revoke-certification.component';
import { CommonFeatureEntryInterface } from 'src/app/model/commonFeature/common-feature-entry-interface';
import { CommonFeatureInterface } from 'src/app/model/commonFeature/common-feature-interface';
import { OrganisationChangeInterface } from 'src/app/model/organisations/organisation-change-interface';
import { OrganisationInterface } from 'src/app/model/organisations/organisation-interface';
import { DialogConfirmDelegateCertificationComponent } from 'src/app/components/dialog-windows/dialog-confirm-delegate-certification.component';
import { CertificationRequestStatus } from 'src/app/model/enums/certification-requests-status';
import { DialogFileRequestComponent } from 'src/app/components/dialog-windows/dialog-certReq-requestFile.component';
import { DialogCookieConsentComponent } from 'src/app/components/dialog-windows/dialog-cookie-consent/dialog-cookie-consent.component';
import { AttributeInterface } from 'src/app/model/attributes/attribute-interface';
import { DialogBackendServiceUnavailableComponent } from 'src/app/components/dialog-windows/dialog-backend-service-unavailable/dialog-backend-service-unavailable/dialog-backend-service-unavailable.component';
import { DialogInfoComponent } from 'src/app/components/dialog-windows/dialog-info/dialog-info.component';
import { DialogFileUploadLoadingComponent } from 'src/app/components/dialog-windows/dialog-file-upload-loading/dialog-file-upload-loading.component';
import { DialogAboVerwaltungComponent } from 'src/app/components/dialog-windows/dialog-abo-verwaltung/dialog-abo-verwaltung.component';
import { DialogLoginComponent } from 'src/app/components/dialog-windows/dialog-login/dialog-login.component';
import { DialogErrorComponent } from 'src/app/components/dialog-windows/dialog-error/dialog-error.component';
import { DialogUserReviewHistoryComponent } from 'src/app/components/dialog-windows/dialog-user-review-history/dialog-user-review-history.component';
import { ProductLizenzDialogComponent } from 'src/app/components/product-certification/products/products/product-lizenz-dialog/product-lizenz-dialog.component';
import { DialogContractTransfer } from 'src/app/components/dialog-windows/dialog-contract-transfer/dialog-contract-transfer.component';
import { XmlPreviewDialogComponent } from 'src/app/components/dialog-windows/dialog-xml-preview/dialog-xml-preview.component';
import { DialogJson } from 'src/app/components/dialog-windows/dialog-json/dialog-json.component';
import { OrganisationOntologyOverviewInterface } from 'src/app/model/organisations/organisation-ontology-overview-interface';
import { OrganisationImportDialogComponent } from 'src/app/components/organisation-user-settings/views-user-settings/organisation-screen/organisation-import-dialog/organisation-import-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class DialogService {
    private replyComposeConfig$ = new BehaviorSubject<any | null>(null);

    constructor(private dialog: MatDialog) { }

    setReplyComposeConfig(cfg: any) {
        this.replyComposeConfig$.next(cfg);
    }

    getReplyComposeConfig() {
        return this.replyComposeConfig$.asObservable();
    }

    openDialog(title, message): Observable<any> {
        const reference = this.dialog.open(
            DialogOverviewExampleDialogComponent,
            {
                width: '500px',
                data: {
                    title: title,
                    message: message
                }
            }
        );
        return reference.afterClosed();
    }

    openXmlPreviewDialog(xml: string): void {
        this.dialog.open(XmlPreviewDialogComponent, {
            width: '70vw',
            data: { xml: xml }
        });
    }

    openTextDialog(
        title: string,
        text: string,
        buttonYesLabel: string,
        buttonNoLabel: string
    ): Observable<any> {
        const reference = this.dialog.open(DialogText, {
            width: '75vw',
            data: {
                title: title,
                buttonNo: buttonNoLabel,
                buttonYes: buttonYesLabel,
                message: text
            }
        });
        return reference.afterClosed();
    }

    /** Dialogfenster was zur reinen Information des Users dient */
    openTextDialogInform(
        title: string,
        text: string,
        buttonNoLabel: string
    ): Observable<any> {
        const reference = this.dialog.open(DialogText, {
            width: '75vw',
            data: {
                title: title,
                buttonNo: buttonNoLabel,
                message: text
            }
        });
        return reference.afterClosed();
    }

    openJSONDialog(
        row: Pick<
            OrganisationOntologyOverviewInterface,
            'organisationName' | 'valuesJson'
        >
    ) {
        this.dialog.open(DialogJson, {
            width: '600px',
            data: {
                organisationName: row.organisationName,
                valuesJson: row.valuesJson
            }
        });
    }

    openchangeProductLicenseDialog(
        title: string,
        buttonNoLabel: string,
        buttonYesLabel: string,
        productId: any,
        message?: string,

    ): Observable<boolean | string> {
        const reference = this.dialog.open(ProductLizenzDialogComponent, {
            width: '70vw',
            data: {
                title: title,
                buttonNo: buttonNoLabel,
                buttonYes: buttonYesLabel,
                message: message,
                productId: productId
            }
        });
        reference.backdropClick().subscribe(() => {
            reference.close('backdropClick');
        });
        return reference.afterClosed();
    }


    openUserReviewHistoryDialog(
        userId: string, index: number
    ): Observable<any> {
        const reference = this.dialog.open(DialogUserReviewHistoryComponent, {
            width: '95vw',
            maxWidth: '95vw',
            height: '90vh',
            data: {
                userId: userId,
                index: index
            }
        });
        return reference.afterClosed();
    }


    /** Dialogfenster was zur reinen Information des Users dient uber Privacy */
    openPrivacyDialogInform(buttonNoLabel: string): Observable<any> {
        const reference = this.dialog.open(DialogPrivacy, {
            width: '75vw',
            autoFocus: false,
            maxHeight: '90vh',
            data: {
                buttonNo: buttonNoLabel
            }
        });
        return reference.afterClosed();
    }

    /** Dialogfenster was zur reinen Information des Users dient uber Agb */
    openAgbDialogInform(buttonNoLabel: string): Observable<any> {
        const reference = this.dialog.open(DialogAgb, {
            width: '75vw',
            autoFocus: false,
            maxHeight: '90vh',
            data: {
                buttonNo: buttonNoLabel,
                openPrivacy: () => this.openPrivacyDialogInform('Schließen')
            }
        });
        return reference.afterClosed();
    }

    /** Dialogwindow with information regarding contract transfer */
    openContractTransferDialogInform(buttonNoLabel: string): Observable<any> {
        const reference = this.dialog.open(DialogContractTransfer, {
            width: '75vw',
            autoFocus: false,
            maxHeight: '90vh',
            data: {
                buttonNo: buttonNoLabel,
            }
        });
        return reference.afterClosed();
    }

    openDialogAttribute(feature: AttributeInterface): Observable<boolean> {
        const reference = this.dialog.open(DialogAttributeCreate, {
            width: '500px',
            data: {
                feature: feature
            }
        });

        return reference.afterClosed();
    }

    openConfirmDialog(
        title: string,
        buttonNoLabel: string,
        buttonYesLabel: string,
        message?: string
    ): Observable<boolean> {
        const reference = this.dialog.open(DialogConfirmComponent, {
            width: 'auto',
            data: {
                title: title,
                buttonNo: buttonNoLabel,
                buttonYes: buttonYesLabel,
                message: message
            }
        });
        return reference.afterClosed();
    }

    openFileManagerDialog(
        title: string,
        buttonNoLabel: string,
        buttonYesLabel: string,
        message: string,
        option?: Options,
        fileId?: string
    ): Observable<Array<string>> {
        let multi: boolean = false;
        let filter: boolean | String = false;
        let upload: boolean = true;
        if (option != null) {
            if (option.multi != null) {
                multi = option.multi;
            }
            if (option.filter != null) {
                filter = option.filter;
            }
            if (option.upload != null) {
                upload = option.upload;
            }
        }
        const reference = this.dialog.open(DialogFileManagerComponent, {
            width: 'auto',
            data: {
                title: title,
                buttonNo: buttonNoLabel,
                buttonYes: buttonYesLabel,
                message: message,
                multiSelect: multi,
                uploadDisable: upload == false,
                filter: filter,
                fileId: fileId
            }
        });
        return reference.afterClosed();
    }

    openCommonFeatureEditDialog(
        selected: {
            feature: CommonFeatureInterface;
            entry: CommonFeatureEntryInterface;
        }[]
    ): Observable<
        {
            feature: CommonFeatureInterface;
            entry: CommonFeatureEntryInterface;
        }[]
    > {
        const reference = this.dialog.open(
            DialogCommonFeatureProductCreationComponent,
            {
                width: '60vw',
                data: {
                    selected: selected
                }
            }
        );
        return reference.afterClosed();
    }

    openDemoRequestDialog(productId: number): void {
        this.dialog.open(DialogRequestComponent, {
            width: 'auto',
            data: {
                title: 'Demo-Anfrage',
                productId: productId,
                type: RequestType.DEMO,
                openAgb: () => this.openAgbDialogInform('Schließen'),
                openPrivacy: () => this.openPrivacyDialogInform('Schließen')
            }
        });
    }

    openTarifeSelectionDialog(tarifeId: string, tarifeName: string, ProductsToShow: PackageModel[]): Observable<any> {
        const reference = this.dialog.open(DialogTarifeComponent, {
            width: '80vw',
            maxWidth: '800px',
            data: {
                title: 'Produkt Listung',
                id: tarifeId,
                name: tarifeName,
                ProductsToShow: ProductsToShow
            }
        });
        return reference.afterClosed();
    }

    openAboVerwaltungDialog(abo: any): void {
        this.dialog.open(DialogAboVerwaltungComponent, {
            width: '80vw',
            data: {
                title: 'Abonnement Verwaltung',
                abo: abo
            }
        });
    }

    openOfferRequestDialog(productId: number): void {
        this.dialog.open(DialogRequestComponent, {
            width: 'auto',
            data: {
                title: 'Angebot-Anfrage',
                productId: productId,
                type: RequestType.OFFER,
                openAgb: () => this.openAgbDialogInform('Schließen'),
                openPrivacy: () => this.openPrivacyDialogInform('Schließen')
            }
        });
    }

    openListingRequestDialog(): void {
        this.dialog.open(DialogRequestComponent, {
            width: 'auto',
            data: {
                title: 'Kontakt Formular',
                type: RequestType.LISTING,
                openAgb: () => this.openAgbDialogInform('Schließen'),
                openPrivacy: () => this.openPrivacyDialogInform('Schließen')
            }
        });
    }

    /** oeffnet ein Dialogfenster fuer Zertifikats Angebotsanfragen */
    openOfferCertRequestDialog(certId: number): void {
        this.dialog.open(DialogCertRequestComponent, {
            width: 'auto',
            data: {
                title: 'Angebot-Anfrage',
                productId: certId,
                type: RequestType.OFFER,
                openAgb: () => this.openAgbDialogInform('Schließen'),
                openPrivacy: () => this.openPrivacyDialogInform('Schließen')
            }
        });
    }

    public openRemoveMemberDialog(
        username: string
    ): Observable<{ confirmed: boolean; message: string }> {
        const reference = this.dialog.open(DialogRemoveMemberConfirmComponent, {
            width: 'auto',
            data: {
                username: username
            }
        });
        return reference.afterClosed();
    }

    public openDeleteUserDialog(
        userId: number,
        organisationMemberships: OrganisationInterface[]
    ): Observable<{
        confirmed: boolean;
        organisationChanges: OrganisationChangeInterface[];
    }> {
        const reference = this.dialog.open(
            DialogDeleteUserManageOrganisationsComponent,
            {
                width: '80vw',
                data: {
                    userId: userId,
                    organisationMemberships: organisationMemberships
                }
            }
        );

        return reference.afterClosed();
    }

    public openAddProductToToolchainItem(
        toolchainItemName,
        toolchainItemDescription
    ): Observable<{
        productName: string;
        productId: string;
        productFileId: string;
    }> {
        const reference = this.dialog.open(DialogAddProductToNodeComponent, {
            width: '80vw',
            data: {
                toolchainItemName,
                toolchainItemDescription
            }
        });

        return reference.afterClosed();
    }

    public openEditToolchainMetaData(
        modeling: any,
        id: string,
        name: string,
        description: string,
        selectedPTGs: number[],
        productName: string,
        productId: string,
        productFileId: string,
        element: any
    ) {
        this.dialog.open(DialogEditMetaDataComponent, {
            width: '40vw',
            height: '40vh',
            data: {
                modeling: modeling,
                dialogService: this,
                id: id,
                name: name,
                description: description,
                selectedPTGs: selectedPTGs,
                productName: productName,
                productId: productId,
                productFileId: productFileId,
                element: element
            }
        });
    }

    openCertReqChangeStatusDialog(
        title: string
    ): Observable<CertificationRequestStatus> {
        const reference = this.dialog.open(DialogCertReqChangeStatusComponent, {
            width: 'auto',
            data: {
                title: title
            }
        });
        return reference.afterClosed();
    }

    openDelegateCertificationDialog(
        title: string,
        delegatedToOrganisations: OrganisationOverview[]
    ): Observable<OrganisationOverview> {
        const reference = this.dialog.open(
            DialogDelegateCertificationComponent,
            {
                width: 'auto',
                data: {
                    title: title,
                    delegatedToOrganisations: delegatedToOrganisations
                }
            }
        );
        return reference.afterClosed();
    }

    openConfirmDelegateCertificationDialog(
        title: string,
        certificationOffices: OrganisationOverview[],
        attributeOrPtg: string
    ): Observable<boolean> {
        const reference = this.dialog.open(
            DialogConfirmDelegateCertificationComponent,
            {
                width: 'auto',
                data: {
                    title: title,
                    certificationOffices: certificationOffices,
                    attributeOrPtg: attributeOrPtg
                }
            }
        );
        return reference.afterClosed();
    }

    openFileRequestDialog(
        title: string,
        buttonNoLabel: string,
        buttonYesLabel: string
    ): Observable<string> {
        const reference = this.dialog.open(DialogFileRequestComponent, {
            width: 'auto',
            data: {
                title: title,
                buttonNoLabel: buttonNoLabel,
                buttonYesLabel: buttonYesLabel
            }
        });
        return reference.afterClosed();
    }

    openReportReviewDialog(
        buttonNoLabel: string,
        buttonYesLabel: string
    ): Observable<string> {
        const dat: ReportReviewDialogData = {
            buttonNo: buttonNoLabel,
            buttonYes: buttonYesLabel
        };
        const reference = this.dialog.open(DialogReportReviewComponent, {
            width: '50vw',
            data: dat
        });
        return reference.afterClosed();
    }

    public openToolchainInstanceDataUpload(
        containerId: string,
        contentId: string
    ): Observable<String[]> {
        const reference = this.dialog.open(
            DialogToolchainInstanceUploadDataComponent,
            {
                width: '40vw',
                data: {
                    containerId: containerId,
                    contentId: contentId
                }
            }
        );
        return reference.afterClosed();
    }

    openCookieConsentDialog(
        title: string,
        buttonYesLabel: string,
        message?: string
    ): Observable<boolean> {
        const reference = this.dialog.open(DialogCookieConsentComponent, {
            width: 'auto',
            data: {
                title: title,
                buttonYes: buttonYesLabel,
                message: message
            },
            disableClose: true
        });
        return reference.afterClosed();
    }

    openBackendServiceUnavailabeDialog(): MatDialogRef<
        DialogBackendServiceUnavailableComponent,
        any
    > {
        const reference = this.dialog.open(
            DialogBackendServiceUnavailableComponent,
            {
                width: 'auto',
                disableClose: true
            }
        );
        return reference;
    }

    openInfoDialog(title: string, message: string): void {
        this.dialog.open(DialogInfoComponent, {
            width: '40%',
            data: {
                title: title,
                message: message
            }
        });
    }

    openWiderInfoDialog(title: string, message: string): void {
        this.dialog.open(DialogInfoComponent, {
            width: '60vw',
            maxWidth: '90vw',
            data: {
                title: title,
                message: message
            }
        });
    }

    openRevokeCertificationDialog(data: RevokeCertificationDialogData): MatDialogRef<DialogRevokeCertificationComponent, string> {
        return this.dialog.open(DialogRevokeCertificationComponent, {
            width: '50vw',
            height: '50vh',
            maxWidth: '90vw',
            data: data
        });
    }

    openFileUploadLoadingDialog(
        message: string
    ): MatDialogRef<DialogFileUploadLoadingComponent, any> {
        const reference = this.dialog.open(DialogFileUploadLoadingComponent, {
            width: '50%',
            data: { title: message }
        });
        return reference;
    }

    openLoginDialog(): Observable<any> {
        const reference = this.dialog.open(DialogLoginComponent, {
            // width: '80vw',
            // data: {
            // }
        });
        return reference.afterClosed();
    }

    openErrorDialog(message: string, buttonNoLabel: string, buttonYesLabel: string): Observable<string> {
        const reference = this.dialog.open(DialogErrorComponent, {
            width: '50vw',
            data: {
                title: message,
                buttonNo: buttonNoLabel,
                buttonYes: buttonYesLabel,
            }
        });
        return reference.afterClosed();
    }
    openOrganisationImportDialog(): Observable<any> {
        const reference = this.dialog.open(OrganisationImportDialogComponent, {
            width: '80vw',
            maxWidth: '95vw',
            height: 'auto',
            maxHeight: '90vh',
            data: {}
        });
        return reference.afterClosed();
    }
}

export interface Options {
    multi?: boolean;
    filter?: boolean | String;
    upload?: boolean;
}

export interface ReportReviewDialogData {
    buttonNo: string;
    buttonYes: string;
}
